var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6283 8.37707L15.623 8.37704M18.2688 4.37616L13.4351 4.00434C13.0066 3.97138 12.585 4.12732 12.2811 4.43124L4.43123 12.2811C3.85626 12.8561 3.85626 13.7883 4.43123 14.3633L9.63669 19.5688C10.2117 20.1437 11.1439 20.1437 11.7189 19.5688L19.5688 11.7189C19.8727 11.415 20.0286 10.9934 19.9957 10.5649L19.6238 5.73123C19.5681 5.00717 18.9928 4.43186 18.2688 4.37616Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTag);
export default __webpack_public_path__ + "static/media/icon-tag.17af262ad5d22d27cf1d794617af6d02.svg";
export { ForwardRef as ReactComponent };